var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cnehl-main",style:({ 
    'width': '100%',
    'height': '100%',
    'position': 'relative'})},[_c('div',{staticClass:"reprint",style:({
      'width': ((67 * _vm.zoomLevel) + "px"),
      'height': ((15 * _vm.zoomLevel) + "px"),
      'font-size': ((8 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((9 * _vm.zoomLevel) + "px"),
      'left': ((720 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {@Reprint}\n    ")]),_c('div',{staticClass:"userid",style:({
      'width': ((67 * _vm.zoomLevel) + "px"),
      'height': ((15 * _vm.zoomLevel) + "px"),
      'font-size': ((8 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((22 * _vm.zoomLevel) + "px"),
      'left': ((720 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['userid'])+"\n    ")]),_c('div',{staticClass:"urgency",style:({
      'width': ((100 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((68 * _vm.zoomLevel) + "px"),
      'left': ((530 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Urgent'] == '1' ? 'URGENT' : '')+"\n    ")]),_c('div',{staticClass:"office-hour",style:({
      'width': ((150 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((113 * _vm.zoomLevel) + "px"),
      'left': ((40 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['OfficeHours'] == '1' ? 'OFFICE HR' : _vm.cn['OfficeHours'] == '0' ? '24 HRS' : '')+"\n    ")]),_c('div',{staticClass:"last-day",style:({
      'width': ((150 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((113 * _vm.zoomLevel) + "px"),
      'left': ((300 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.getLastDay())+"\n    ")]),_c('div',{staticClass:"booking-ref",style:({
      'width': ((198 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((138 * _vm.zoomLevel) + "px"),
			'left': ((138 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Booking Ref No'])+"\n    ")]),_c('div',{staticClass:"request-no",style:({
      'width': ((98 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((137 * _vm.zoomLevel) + "px"),
			'left': ((444 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Request No'])+"\n    ")]),_c('div',{staticClass:"cn-no",style:({
      'width': ((118 * _vm.zoomLevel) + "px"),
      'height': ((39 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((190 * _vm.zoomLevel) + "px"),
      'left': ((15 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ConsignmentNo'])+"\n    ")]),_c('div',{staticClass:"date-time",style:({
      'width': ((96 * _vm.zoomLevel) + "px"),
			'height': ((39 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((190 * _vm.zoomLevel) + "px"),
			'left': ((140 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm'))+"\n    ")]),_c('div',{staticClass:"acc-no",style:({
      'width': ((96 * _vm.zoomLevel) + "px"),
			'height': ((39 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((190 * _vm.zoomLevel) + "px"),
			'left': ((241 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Account No}\n    ")]),_c('div',{staticClass:"haulage-amt",style:({
      'width': ((96 * _vm.zoomLevel) + "px"),
			'height': ((24 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((204 * _vm.zoomLevel) + "px"),
			'left': ((343 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['HaulageRate'])+"\n    ")]),_c('div',{staticClass:"toll-amt",style:({
      'width': ((96 * _vm.zoomLevel) + "px"),
			'height': ((24 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((204 * _vm.zoomLevel) + "px"),
			'left': ((445 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['TollRate'])+"\n    ")]),_c('div',{staticClass:"others-amt",style:({
      'width': ((96 * _vm.zoomLevel) + "px"),
			'height': ((24 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((204 * _vm.zoomLevel) + "px"),
			'left': ((548 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Others Amount}\n    ")]),_c('div',{staticClass:"total-amt",style:({
      'width': ((96 * _vm.zoomLevel) + "px"),
			'height': ((24 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((204 * _vm.zoomLevel) + "px"),
			'left': ((651 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.getTotalAmount())+"\n    ")]),_c('div',{staticClass:"cont-no",style:({
      'width': ((221 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((242 * _vm.zoomLevel) + "px"),
			'left': ((15 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContainerNo'])+"\n    ")]),_c('div',{staticClass:"size",style:({
      'width': ((196 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((242 * _vm.zoomLevel) + "px"),
			'left': ((243 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContSize'])+"\n    ")]),_c('div',{staticClass:"height",style:({
      'width': ((149 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((242 * _vm.zoomLevel) + "px"),
			'left': ((448 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContHeight'])+"\n    ")]),_c('div',{staticClass:"gross-weight",style:({
      'width': ((143 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((242 * _vm.zoomLevel) + "px"),
			'left': ((603 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContWeight'])+"\n    ")]),_c('div',{staticClass:"cont-type",style:({
      'width': ((221 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((273 * _vm.zoomLevel) + "px"),
			'left': ((15 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContType'])+"\n    ")]),_c('div',{staticClass:"status",style:({
      'width': ((196 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((273 * _vm.zoomLevel) + "px"),
			'left': ((243 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['Status'])+"\n    ")]),_c('div',{staticClass:"seal",style:({
      'width': ((149 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((273 * _vm.zoomLevel) + "px"),
			'left': ((448 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['SealNo'])+"\n    ")]),_c('div',{staticClass:"measurement",style:({
      'width': ((143 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((273 * _vm.zoomLevel) + "px"),
			'left': ((603 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContMeasure'])+"\n    ")]),_c('div',{staticClass:"import-export-others",style:({
      'width': ((221 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((305 * _vm.zoomLevel) + "px"),
			'left': ((15 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Job Type'])+"\n    ")]),_c('div',{staticClass:"temperature",style:({
      'width': ((196 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((305 * _vm.zoomLevel) + "px"),
			'left': ((243 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['Temperature'])+"\n    ")]),_c('div',{staticClass:"cargo",style:({
      'width': ((149 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((305 * _vm.zoomLevel) + "px"),
			'left': ((448 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Cargo}\n    ")]),_c('div',{staticClass:"trip",style:({
      'width': ((143 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((305 * _vm.zoomLevel) + "px"),
			'left': ((603 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Trip'])+"\n    ")]),_c('div',{staticClass:"vessel-name",style:({
      'width': ((424 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((337 * _vm.zoomLevel) + "px"),
			'left': ((15 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Vessel No'])+" "+_vm._s(_vm.job['Vessel Name'])+"\n    ")]),_c('div',{staticClass:"special-handling",style:({
      'width': ((298 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((337 * _vm.zoomLevel) + "px"),
			'left': ((448 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['HandlingType'])+"\n    ")]),_c('div',{staticClass:"voyage-no",style:({
      'width': ((221 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((370 * _vm.zoomLevel) + "px"),
			'left': ((15 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Voy No'])+"\n    ")]),_c('div',{staticClass:"eta",style:({
      'width': ((196 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((370 * _vm.zoomLevel) + "px"),
			'left': ((243 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(Date.parse(_vm.job['POD ETA']) ? _vm.$dateTime.getDateTime(new Date(_vm.job['POD ETA']), 'dd/MM/yyyy HH:mm') : '')+"\n    ")]),_c('div',{staticClass:"delivery-type",style:({
      'width': ((298 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((370 * _vm.zoomLevel) + "px"),
			'left': ((448 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['DeliveryType'])+"\n    ")]),_c('div',{staticClass:"trans-port",style:({
      'width': ((221 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((401 * _vm.zoomLevel) + "px"),
			'left': ((15 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Transhipment Port'])+"\n    ")]),_c('div',{staticClass:"dest-port",style:({
      'width': ((196 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((401 * _vm.zoomLevel) + "px"),
			'left': ((243 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Destination Port}\n    ")]),_c('div',{staticClass:"port-code",style:({
      'width': ((298 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((12 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((401 * _vm.zoomLevel) + "px"),
			'left': ((448 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Port Code}\n    ")]),_c('div',{staticClass:"pickup",style:({
      'width': ((360 * _vm.zoomLevel) + "px"),
      'height': ((39 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((442 * _vm.zoomLevel) + "px"),
      'left': ((18 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['PickUp'])+"\n    ")]),_c('div',{staticClass:"contact-person",style:({
      'width': ((179 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((480 * _vm.zoomLevel) + "px"),
      'left': ((18 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Contact Person}\n    ")]),_c('div',{staticClass:"tel",style:({
      'width': ((179 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((480 * _vm.zoomLevel) + "px"),
      'left': ((199 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Tel}\n    ")]),_c('div',{staticClass:"bill-to",style:({
      'width': ((355 * _vm.zoomLevel) + "px"),
			'height': ((57 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((440 * _vm.zoomLevel) + "px"),
			'left': ((390 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Bill To}\n    ")]),_c('div',{staticClass:"deliver-to",style:({
      'width': ((360 * _vm.zoomLevel) + "px"),
			'height': ((52 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((521 * _vm.zoomLevel) + "px"),
			'left': ((18 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['SendTo'])+"\n    ")]),_c('div',{staticClass:"contact-person",style:({
      'width': ((179 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((572 * _vm.zoomLevel) + "px"),
      'left': ((18 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Contact Person Del}\n    ")]),_c('div',{staticClass:"tel",style:({
      'width': ((179 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((572 * _vm.zoomLevel) + "px"),
      'left': ((199 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Tel Del}\n    ")]),_c('div',{staticClass:"shipper",style:({
      'width': ((355 * _vm.zoomLevel) + "px"),
			'height': ((72 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((521 * _vm.zoomLevel) + "px"),
			'left': ((390 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Shipper / Consignee}\n    ")]),_c('div',{staticClass:"drop-off",style:({
      'width': ((360 * _vm.zoomLevel) + "px"),
			'height': ((72 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((622 * _vm.zoomLevel) + "px"),
			'left': ((18 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['DropOff'])+"\n    ")]),_c('div',{staticClass:"fumigation",style:({
      'width': ((225 * _vm.zoomLevel) + "px"),
			'height': ((20 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((698 * _vm.zoomLevel) + "px"),
			'left': ((18 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['Fumigation'] == '1' ? 'YES' : _vm.cn['Fumigation'] == '0' ? 'NO' : '')+"\n    ")]),_c('div',{staticClass:"required-date",style:({
      'width': ((95 * _vm.zoomLevel) + "px"),
			'height': ((17 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((617 * _vm.zoomLevel) + "px"),
			'left': ((520 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(Date.parse(_vm.cn['RequiredTime']) ? _vm.$dateTime.getDateTime(new Date(_vm.cn['RequiredTime']), 'dd/MM/yyyy') : '')+"\n    ")]),_c('div',{staticClass:"required-time",style:({
      'width': ((225 * _vm.zoomLevel) + "px"),
			'height': ((17 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((617 * _vm.zoomLevel) + "px"),
			'left': ((650 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(Date.parse(_vm.cn['RequiredTime']) ? _vm.$dateTime.getDateTime(new Date(_vm.cn['RequiredTime']), 'HH:mm') : '')+"\n    ")]),_c('div',{staticClass:"offload",style:({
      'width': ((225 * _vm.zoomLevel) + "px"),
			'height': ((17 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((630 * _vm.zoomLevel) + "px"),
			'left': ((650 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['OffLoad'])+"\n    ")]),_c('div',{staticClass:"forwarder",style:({
      'width': ((225 * _vm.zoomLevel) + "px"),
			'height': ((17 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((647 * _vm.zoomLevel) + "px"),
			'left': ((520 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Frt Forwarder Name'])+"\n    ")]),_c('div',{staticClass:"shipping-agent",style:({
      'width': ((225 * _vm.zoomLevel) + "px"),
			'height': ((17 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((662 * _vm.zoomLevel) + "px"),
			'left': ((520 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Shipping Agt Name'])+"\n    ")]),_c('div',{staticClass:"cont-operator",style:({
      'width': ((225 * _vm.zoomLevel) + "px"),
			'height': ((17 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((677 * _vm.zoomLevel) + "px"),
			'left': ((520 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContOperator'])+"\n    ")]),_c('div',{staticClass:"requested-by",style:({
      'width': ((225 * _vm.zoomLevel) + "px"),
			'height': ((17 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((692 * _vm.zoomLevel) + "px"),
			'left': ((520 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Requested By'])+"\n    ")]),_c('div',{staticClass:"remarks",style:({
      'width': ((290 * _vm.zoomLevel) + "px"),
			'height': ((45 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((987 * _vm.zoomLevel) + "px"),
			'left': ((450 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['Remarks'])+"\n    ")]),_c('div',{staticClass:"delivery-type",style:({
      'width': ((300 * _vm.zoomLevel) + "px"),
			'height': ((30 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((1042 * _vm.zoomLevel) + "px"),
			'left': ((20 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['DeliveryType'] == 'SL' ? 'SIDELOADER' : _vm.cn['DeliveryType'] == 'TP' ? 'TIPPER' : _vm.cn['DeliveryType'] == 'GS' ? 'GENSET' : '')+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }